export default __webpack_public_path__ + "static/7-2c5361cddf6050dca2b32f8b129dc01c.jpg";